var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "mt-5 d-flex align-items-end justify-content-center" },
          [_c("b-spinner", { attrs: { variant: "primary" } })],
          1
        )
      : _vm._e(),
    !_vm.loading
      ? _c(
          "div",
          [
            _vm.mockedSteps.length
              ? _c(
                  "vs-row",
                  { attrs: { "vs-justify": "center" } },
                  [
                    _c(
                      "vs-col",
                      {
                        attrs: {
                          type: "flex",
                          "vs-justify": "center",
                          "vs-align": "center",
                          "vs-w": "8"
                        }
                      },
                      [
                        _vm.stepList.length > 1
                          ? _c("step-progress", {
                              attrs: {
                                "current-step": _vm.currentStep,
                                steps: _vm.mockedSteps,
                                "active-color": _vm.colors.primario,
                                "active-thickness": 0,
                                "passive-thickness": 0,
                                "line-thickness": 8
                              }
                            })
                          : _vm._e(),
                        _vm.stepList.length === 1
                          ? _c("div", { staticClass: "mt-5" })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "vs-row",
              { attrs: { "vs-justify": "center" } },
              [
                _c(
                  "vs-col",
                  {
                    attrs: {
                      type: "flex",
                      "vs-justify": "center",
                      "vs-align": "center",
                      "vs-w": "10"
                    }
                  },
                  [
                    !_vm.isConventionOrSISS && _vm.wizardData.fileNumber
                      ? _c("h4", { staticStyle: { color: "#662583" } }, [
                          _vm._v(
                            " Expediente # " +
                              _vm._s(_vm.wizardData.fileNumber) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    _vm.isConventionOrSISS && "dnt" in _vm.detailsFile
                      ? _c("h4", { staticClass: "text-primary" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.detailsFile.dnt.categoria
                                  ? "Respuesta a expediente: " +
                                      _vm.titleWizardDnt
                                  : "Respuesta a expediente: " +
                                      _vm.detailsFile.dnt.numeroExt
                              ) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _c(
              "vs-row",
              { attrs: { "vs-justify": "center" } },
              [
                _c(
                  "vs-col",
                  { attrs: { "vs-w": "10" } },
                  [
                    _c("vs-card", { attrs: { id: "wizard" } }, [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("h3", [
                          _vm._v(" " + _vm._s(_vm.currentStepTitle) + " ")
                        ])
                      ]),
                      _vm.currentStepSetting
                        ? _c(
                            "div",
                            [
                              _c(_vm.currentStepComponent, {
                                ref: "step",
                                tag: "component",
                                attrs: {
                                  "company-to-load": _vm.currentCompany,
                                  wizard: _vm.wizard,
                                  draft: _vm.wizardData,
                                  lazy: _vm.isLazyStep
                                },
                                on: {
                                  "update-steps": _vm.updateSteps,
                                  loaded: _vm.onStepLoaded
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.wizard.options
                        ? _c(
                            "div",
                            {
                              staticClass: "mt-4 pt-5",
                              attrs: { slot: "footer" },
                              slot: "footer"
                            },
                            [
                              _c(
                                "vs-row",
                                { attrs: { "vs-justify": "flex-end" } },
                                [
                                  !_vm.isFirstStep
                                    ? _c(
                                        "vs-button",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "data-cy": "back-button"
                                          },
                                          on: { click: _vm.onBack }
                                        },
                                        [_vm._v(" Volver ")]
                                      )
                                    : _vm._e(),
                                  _vm.wizard.options.includes("draft")
                                    ? _c(
                                        "CheckPermission",
                                        { attrs: { permission: "ED014" } },
                                        [
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                "data-cy": "save-draft-button",
                                                color: "primary"
                                              },
                                              on: { click: _vm.onBackup }
                                            },
                                            [_vm._v(" Guardar Borrador ")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.wizard.options.includes("flow") &&
                                  _vm.isLastStep &&
                                  !_vm.isMop
                                    ? _c(
                                        "CheckPermission",
                                        { attrs: { permission: "ED046" } },
                                        [
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                "data-cy": "send-to-flow",
                                                color: "warning"
                                              },
                                              on: { click: _vm.onFlow }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Enviar a flujo de firmas"
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.wizard.options.includes("flow") &&
                                  _vm.isLastStep &&
                                  _vm.isMop
                                    ? _c(
                                        "CheckPermission",
                                        { attrs: { permission: "ED046" } },
                                        [
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { color: "warning" },
                                              on: { click: _vm.onFlow }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Crear expediente y generar flujo"
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.wizard.options.includes("submit")
                                    ? _c(
                                        "CheckPermission",
                                        { attrs: { permission: "ED015" } },
                                        [
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                "data-cy": "next-button",
                                                color: "success"
                                              },
                                              on: { click: _vm.onNext }
                                            },
                                            [
                                              _vm.isLastStep
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.submitButtonText
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              !_vm.isLastStep &&
                                              _vm.wizard.displayNextTitle
                                                ? _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.nextStepTitle
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                : _vm._e(),
                                              !_vm.isLastStep &&
                                              !_vm.wizard.displayNextTitle
                                                ? _c("span", [
                                                    _vm._v(" Siguiente ")
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.wizard.options.includes(
                                    "submitNumeration"
                                  ) && !_vm.isLastStep
                                    ? _c(
                                        "CheckPermission",
                                        { attrs: { permission: "ED015" } },
                                        [
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                "data-cy": "next-button",
                                                color: "success"
                                              },
                                              on: { click: _vm.onNext }
                                            },
                                            [_c("span", [_vm._v("Siguiente")])]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }